module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white@2x-401c678f46faf263893542a0a492d04b.png";